import type { CSSObject } from "tss-react"

import { LocalCache, StorageKey } from "../../../../../shared/cache/LocalCache"
import type { StandardChipVariantType } from "../../../../../shared/components/badges/StandardChip"
import type { MenuMeeting } from "../../../../nonAdminUser/reports/home/weekMenuTypes"

import { MeetingRoomBookingState } from "../meetingRoomsTypes"
import type { MeetingRoomBooking } from "../meetingRoomsTypes"

export const BOOKING_STATE_CHIP_VARIANTS: Record<MeetingRoomBookingState, StandardChipVariantType> = {
    [MeetingRoomBookingState.IN_PROGRESS]: "success",
    [MeetingRoomBookingState.FINISHED]: "grey",
    [MeetingRoomBookingState.UPCOMING]: "info",
}

export const LIVE_PULSE: CSSObject = {
    animation: "meeting-rooms-live-pulse 1.8s ease-in-out infinite",
    "@keyframes meeting-rooms-live-pulse": {
        "0%, 100%": { opacity: 1, transform: "scale(1)" },
        "50%": { opacity: 0.45, transform: "scale(.86)" },
    },
}

// Opacity only, so an element whose size must stay fixed can still blink.
export const LIVE_BLINK: CSSObject = {
    animation: "meeting-rooms-live-blink 1.8s ease-in-out infinite",
    "@keyframes meeting-rooms-live-blink": {
        "0%, 100%": { opacity: 1 },
        "50%": { opacity: 0.45 },
    },
}

export const LIVE_DOT: CSSObject = {
    width: ".375rem",
    height: ".375rem",
    flexShrink: 0,
    borderRadius: "50%",
    backgroundColor: "currentColor",
    ...LIVE_PULSE,
}

const CHART_CLOSED = "0"

const CHART_OPEN = "1"

export function loadOccupancyChartOpen() {
    try {
        return LocalCache().get(StorageKey.SERVICE_CENTER_MEETING_ROOMS_CHART_OPEN) !== CHART_CLOSED
    } catch {
        return true
    }
}

export function saveOccupancyChartOpen(isOpen: boolean) {
    try {
        LocalCache().set(StorageKey.SERVICE_CENTER_MEETING_ROOMS_CHART_OPEN, isOpen ? CHART_OPEN : CHART_CLOSED)
    } catch {
        return
    }
}

// With `menuOnApi` the menu refetches the real orderAction/summary; the fallbacks only satisfy the type.
export function toMenuMeeting(booking: MeetingRoomBooking): MenuMeeting {
    return {
        id: booking.orderId,
        uid: String(booking.orderId),
        orderSummary: {
            participants: booking.participants ?? 0,
            hasCatering: booking.hasCatering ?? false,
            hasBooking: booking.hasBooking ?? true,
            hasAudioVideoEquipment: booking.hasAudioVideoEquipment ?? false,
        },
        organizers: [],
        meetingDetails: {
            meetingName: booking.meetingName ?? "",
            startDateTime: booking.startDateTime ?? "",
            endDateTime: booking.endDateTime ?? "",
        },
    }
}
